export type SampleProject = {
  name: string
  url: string
  firstTaskIdeas: string[]
}

export const sampleProjects = [
  {
    name: "Matter Playground",
    url: "https://github.com/Kiryushin-Andrey/vite-playground",
    firstTaskIdeas: [
      "Add dark mode",
      "Add light mode",
      "Just do something"
    ]
  }
]